import { createContext } from 'react';
import { IncidentStatusOption } from '@/graphql/generated';

export type UpdateStatusWithNoteModalContextType = {
  isOpen: boolean;
  status: IncidentStatusOption | null;
  initialNote?: string;
  onConfirm?: () => void;
  openModal: (params: { 
    status: IncidentStatusOption; 
    initialNote?: string; 
    onConfirm?: () => void 
  }) => void;
  closeModal: () => void;
};

export const UpdateStatusWithNoteModalContext = createContext<UpdateStatusWithNoteModalContextType | undefined>(undefined);
